(() => {
  const GLOBAL_KEY = '__xifunTodaysDrop';
  const DAY_MS = 24 * 60 * 60 * 1000;
  const TAIPEI_OFFSET_MS = 8 * 60 * 60 * 1000;

  const getTaipeiDateParts = (date) => {
    const formatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Asia/Taipei',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hourCycle: 'h23'
    });
    const parts = formatter.formatToParts(date).reduce((result, part) => {
      if (part.type !== 'literal') result[part.type] = Number(part.value);
      return result;
    }, {});
    return parts;
  };

  const getTaipeiDeadline = (date) => {
    const parts = getTaipeiDateParts(date);
    const taipeiDayStartUtc = Date.UTC(parts.year, parts.month - 1, parts.day) - TAIPEI_OFFSET_MS;
    return taipeiDayStartUtc + DAY_MS - 1;
  };

  const setDigits = (element, value) => {
    if (element) element.textContent = String(value).padStart(2, '0');
  };

  const expire = (root) => {
    if (root.dataset.dropExpired === 'true') return;
    root.dataset.dropExpired = 'true';

    const timer = root.querySelector('.todays-drop__countdown');
    const ended = root.querySelector('[data-drop-ended]');
    const announcement = root.querySelector('[data-drop-announcement]');
    const cta = root.querySelector('[data-drop-cta]');

    if (timer) timer.hidden = true;
    if (ended) ended.hidden = false;
    if (announcement) announcement.textContent = '今日限定已結束';

    if (!cta) return;
    if (root.dataset.expiredAction === 'hide') {
      cta.hidden = true;
    } else {
      cta.textContent = '本次活動已結束';
      cta.classList.add('is-disabled');
      cta.setAttribute('aria-disabled', 'true');
      cta.setAttribute('tabindex', '-1');
    }
  };

  const update = (root, deadline) => {
    const now = new Date();
    const remaining = Math.max(0, deadline - now.getTime());

    if (remaining <= 0) {
      setDigits(root.querySelector('[data-drop-hours]'), 0);
      setDigits(root.querySelector('[data-drop-minutes]'), 0);
      setDigits(root.querySelector('[data-drop-seconds]'), 0);
      expire(root);
      return false;
    }

    const timer = root.querySelector('.todays-drop__countdown');
    if (timer) timer.hidden = false;
    const totalSeconds = Math.ceil(remaining / 1000);
    setDigits(root.querySelector('[data-drop-hours]'), Math.floor(totalSeconds / 3600));
    setDigits(root.querySelector('[data-drop-minutes]'), Math.floor((totalSeconds % 3600) / 60));
    setDigits(root.querySelector('[data-drop-seconds]'), totalSeconds % 60);
    return true;
  };

  const init = (root) => {
    if (!root || root.dataset.dropInitialized === 'true') return;
    root.dataset.dropInitialized = 'true';

    const cta = root.querySelector('[data-drop-cta]');
    if (cta) {
      cta.addEventListener('click', (event) => {
        if (cta.getAttribute('aria-disabled') === 'true') event.preventDefault();
      });
    }

    if (!root.querySelector('.todays-drop__countdown')) return;
    const deadline = getTaipeiDeadline(new Date());
    if (!update(root, deadline)) return;
    root.dropTimer = window.setInterval(() => {
      if (!update(root, deadline)) window.clearInterval(root.dropTimer);
    }, 1000);
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-todays-drop]').forEach(init);
  };

  if (!window[GLOBAL_KEY]) {
    window[GLOBAL_KEY] = { initAll };
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-todays-drop]').forEach((root) => window.clearInterval(root.dropTimer));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => window[GLOBAL_KEY].initAll(), { once: true });
  } else {
    window[GLOBAL_KEY].initAll();
  }
})();
